import { NotImplementedError } from "../../../../../errors";
import { parseDateFilter } from "../../../../../models/looker/modules/inventory";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_CAMPAIGN_QUERY } from "../query";
export default class LookerInventoryCampaignFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-inventory-campaign-filter");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const parsedDateFilter = parseDateFilter(dateFilter);
        const queryBody = {
            ...FILTER_OPTIONS_CAMPAIGN_QUERY,
            filters: {
                "billable_agg.filter_date_nyc": parsedDateFilter
            }
        };
        // Add publisher filter if provided
        const publisherFilter = filters.where?.find((filter) => filter.field === "publisherIds");
        if (publisherFilter) {
            queryBody.filters["billable_agg.publisher_id"] = publisherFilter.value.join(",");
        }
        // Add advertiser filter if provided
        const advertiserFilter = filters.where?.find((filter) => filter.field === "advertiserIds");
        if (advertiserFilter) {
            queryBody.filters["conversion_meta_inst.advertiser__id"] = advertiserFilter.value.join(",");
        }
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatCampaignResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch inventory dashboard campaign filter options");
        }));
    }
    formatCampaignResponse(data) {
        const campaignIdToLineItemIds = {};
        const seenCampaignIds = new Set();
        const campaigns = [];
        data.forEach((campaign) => {
            const campaignId = campaign["conversion_meta_inst.campaign__id"];
            const campaignName = campaign["conversion_meta_inst.campaign__name"];
            const lineItemId = campaign["conversion_meta_inst.lineitem__id"];
            if (campaignId) {
                if (!seenCampaignIds.has(campaignId)) {
                    campaigns.push({
                        name: campaignName,
                        id: campaignId
                    });
                    seenCampaignIds.add(campaignId);
                }
                if (!campaignIdToLineItemIds[campaignId]) {
                    campaignIdToLineItemIds[campaignId] = new Set();
                }
                campaignIdToLineItemIds[campaignId].add(lineItemId);
            }
        });
        return {
            campaigns,
            campaignIdToLineItemIds
        };
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Campaign.js.map